module.exports = __webpack_public_path__ + "static/media/zh-CN.5d5d82ce.md";